<div [ngClass]="{'form-group': showLabel}">
  @if (!templateForPermitForm) {
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <!--added by Juber --- start -->
  <input
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="entity.value | date: 'M/d/yyyy'"
  />
  } @else {
    <div class="free-form-text-style">
      <!-- Added by Amisha on 03-07-2026.
          Reason: Janus table-layout view screens already render the row label in the left cell,
          so the readonly value cell should only render this label when showLabel is true. -->
      <wm-common-text
        *ngIf="showLabel"
        [data]="{text: getEntityLabelText()}"
        class="entity-text"

      >
      </wm-common-text>
      <wm-common-text
        [data]="{
          text: entity.value || ''
        }"
      >
      </wm-common-text>
    </div>
  }
  <!--added by Juber --- end -->
</div>
